import { useQuery } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { get } from 'utils/http'

export const useAgency = () => {
  const customerId = useCustomerId()

  const getAgency = async () => {
    const agency = await get(`/management/customers/${customerId}/master`)

    // set total to infinity of at least one of plans is unlimited
    if (Object.keys(agency.usage).some((plan: string) => agency.usage[plan].total === -1)) {
      agency.total = Infinity
    }

    // map -1 to infinity in plan total
    Object.keys(agency.usage).forEach((plan: string) => {
      if (agency.usage[plan].total === -1) {
        agency.usage[plan].total = Infinity
      }
    })

    return agency
  }

  return useQuery({
    queryKey: ['agencies', customerId],
    queryFn: getAgency,
  })
}
